import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgStarHalfFill = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.16 10.638a1.792 1.792 0 0 0-1.56-1.232l-6.453-.52-2.491-6.026a1.789 1.789 0 0 0-3.31 0l-2.49 6.024-6.457.522a1.8 1.8 0 0 0-1.024 3.157l4.921 4.247-1.5 6.35a1.794 1.794 0 0 0 2.68 1.95L14 21.71l5.527 3.4a1.794 1.794 0 0 0 2.676-1.95l-1.505-6.351 4.922-4.247a1.797 1.797 0 0 0 .54-1.924Zm-1.677.598-5.327 4.594a.875.875 0 0 0-.28.865l1.627 6.869a.04.04 0 0 1-.018.052c-.02.015-.025.012-.042 0l-5.985-3.68a.875.875 0 0 0-.458-.128V3.5c.026 0 .03.009.038.028l2.696 6.52a.874.874 0 0 0 .739.537l6.99.565c.017 0 .027 0 .037.031.01.032 0 .044-.017.055Z" />
  </svg>
);
export default SvgStarHalfFill;
